/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component} from '@angular/core';
export class DatagridActionBar {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-dg-action-bar",
    template: `
        <ng-content></ng-content>
    `,
    host: {"[class.datagrid-action-bar]": "true"}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DatagridActionBar_tsickle_Closure_declarations() {
/** @type {?} */
DatagridActionBar.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridActionBar.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
